
import './index.css';

const RecordSection = ({
  className = '',
  title,
  actions = null,
  children = null
}) => {
  return (
    <section className={['card', `${className}-section`].filter(Boolean).join(' ')}>

      <div className="row-between">
        <h3 className="section-title">{title}</h3>
        <div className="action-cluster">
          {actions}
        </div>
      </div>

      {children}
    </section>
  );
};

export default RecordSection;